import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllLegalMatterStageAutocomplete } from './useLegalMatterStageAutocomplete';

export const useCreateLegalMatterStageMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ILegalMatterStage) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			stage,
			impersonationContext,
		}: {
			stage: Api.ILegalMatterStage;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ILegalMatterStage>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'legalMatter/stage',
				}),
				'POST',
				stage
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllLegalMatterStageAutocomplete();
			onSuccess?.(data);
		},
	});
};
